import { stringToHTML } from "../../../GlobalSettings";
import AppSettings from "../../../AppSettings";
import { METAL_TYPE, METAL_FEATURES } from "../core/constants";
import Loader from "../Loader";
import eraser from "../assets/images/eraser.cur";
import selectCursor from "../assets/images/select.cur";

export default class SvgControl {
  constructor(metalType = METAL_TYPE.DEFAULT) {
    this.$designerRoot = document.querySelector(".aam-designer-init");
    this.mainContainer = document.querySelector(".main-container");
    this.metalType = metalType;
    this.trimmedSolidSvg64;
    this.trimmedStrokeSvg64;
    this.rotatePoint;
    this.rotateStatus = false;
    this.isClickToKeep = false; // control for metal lite

    this.loader = new Loader(this.mainContainer);
  }

  // * remove spots of svg 
  removeSpotsHandler(originalSvg, $svgParentElement, numberToDelete) {
    renderedSVG.innerHTML = originalSvg;
    const $svgPath = $svgParentElement.querySelectorAll("svg path");

    // dynamic style
    this.applyStyleOnEnhancementSignature($svgParentElement);

    const filteredSVGArr = [];
    $svgPath.forEach((path) => {
      const isContainsD = path.getAttribute("d");
      if (isContainsD) {
        const dArr = isContainsD.split(" ");
        // delete the smaller path
        if (dArr.length < numberToDelete) {
          path.remove();
        } else {
          // add keep the rest path
          filteredSVGArr.push(path);
        }
      }
    });

    // collect filtered path
    let filteredSVGPaths = "";
    filteredSVGArr.forEach((path) => {
      filteredSVGPaths += path.outerHTML;
    });

    // convert path type into html
    const $filteredPathHTML = stringToHTML(filteredSVGPaths);

    // render svg on the view
    $svgParentElement.querySelector("svg g").innerHTML = $filteredPathHTML;


    // rotate state handling -----------------------------
    if(this.rotateStatus) {
      const currentDeg = $svgParentElement.dataset.degree;
      const svgElement = $svgParentElement.querySelector("svg");
      // no transition in case of noise remove stuff
      svgElement.classList.add("no-transition");
    
      svgElement.style.transform = `rotate(${currentDeg}deg)`;
      svgElement.style.transformOrigin = "center";

       // Fit svg under the svg area in any ratio of signature
      // const svgAreaHeight = $svgParentElement.getBoundingClientRect().height;
      // const svgAreaWidth = $svgParentElement.getBoundingClientRect().width;
      // if (currentDeg === 0 || currentDeg === 180 || currentDeg === -180) {
      //   svgElement.style.width = svgAreaWidth;
      // } else {
      //   svgElement.style.width = svgAreaHeight;
      // }
    }
    
    // rotate state handling end here --------------------

    

    if (this.metalType === METAL_TYPE.LITE && this.isClickToKeep) {
      // active clone selected signature path
      this.clickToStore();
    } else {
      // active erase signature feature
      this.eraseSignatureHandler();
    }
  }

  // * CORE - get svg embed code
  getEmbedSvg(svgUrl) {
    this.loader.show();
    fetch(svgUrl)
      .then((response) => response.text())
      .then((svg) => {
        this.loader.hide();
        // do something with embed svg
        console.log("svg", svg);
        return svg;
      });
  }

  // * apply style on enhancement signature
  applyStyleOnEnhancementSignature($svgParentElement) {
    let strokeColor;
    const fillColor = "transparent",
      thickness = "3%",
      defaultStrokeColor = "#FFFFFF";

    if (this.metalType === METAL_TYPE.LITE) {
      strokeColor = "#000000";
    } else {
      strokeColor = defaultStrokeColor;
    }

    // select all path and apply styles
    const paths = $svgParentElement.querySelectorAll("svg path");
    paths.forEach((path) => {
      path.setAttribute("fill", fillColor);
      path.setAttribute("stroke", strokeColor);
      path.setAttribute("stroke-width", thickness);
    });
  }

  // add svg style
  addSvgStyle(svgElement) {
    svgElement.setAttribute("fill", "transparent");
    svgElement.setAttribute("stroke", this.getStrokeColor());
    svgElement.setAttribute("stroke-width", "0.5%");
  }

  svgTrimStrokeSolidOperation(svg) {
    // Saving solid svg's html to convert it later to base64 svg
    const svgContainer = document.createElement("div");
    svgContainer.setAttribute("id", "svgSign");
    document.body.appendChild(svgContainer);
    svgContainer.classList.add('hide');
    svgContainer.innerHTML = svg;
    const trimmedSolidSvgHTML = document
      .querySelector("#svgSign svg")
      .cloneNode(true);

    // Converting solid to stroke svg and saving stroke svg's html to convert it later to base64 svg
    const x = document.querySelector("#svgSign svg path");
    this.addSvgStyle(x);
    const trimmedStrokeSvgHTML = document.querySelector("#svgSign svg");

    // Converting solid svg to base64 to put onto duplicate designer canvas (used for final submission)
    const solid_xml = new XMLSerializer().serializeToString(
      trimmedSolidSvgHTML
    );
    const solid_svg64 = btoa(solid_xml);
    const solid_b64Start = "data:image/svg+xml;base64,";
    this.trimmedSolidSvg64 = solid_b64Start + solid_svg64;

    // Converting stroke svg to base64 to put onto designer canvas
    const stroke_xml = new XMLSerializer().serializeToString(
      trimmedStrokeSvgHTML
    );
    const stroke_svg64 = btoa(stroke_xml);
    const stroke_b64Start = "data:image/svg+xml;base64,";
    this.trimmedStrokeSvg64 = stroke_b64Start + stroke_svg64;

    // Removing svg html from DOM
    svgContainer.remove();
      
  }

  getTrimmedStrokeSvg() {
    return this.trimmedStrokeSvg64;
  }

  getTrimmedSolidSvg() {
    return this.trimmedSolidSvg64;
  }
  // return color
  getStrokeColor() {
    const defaultStrokeColor = "#FFFFFF";
    let strokeColor;
    if (AppSettings.isSkinSpecificCustomization) {
      const strokeColorKey =
        AppSettings.designerSettings.SkinSpecificCustomization.StrokeColor;
      if (strokeColorKey) {
        strokeColor = "#" + strokeColorKey;
      } else {
        strokeColor = defaultStrokeColor;
      }
    } else {
      strokeColor = defaultStrokeColor;
    }

    return strokeColor;
  }

  // * Erase signature path  
  eraseSignatureHandler() {
    let pathList = renderedSVG.querySelectorAll("svg g path");

    // disable confirm button if signature is empty
    const signatureEmptyValidation = () => {
      pathList = renderedSVG.querySelectorAll("svg g path");
      const btnOptmisationConfirm = this.$designerRoot.querySelector(
        "#btn-optimisation-confirm"
      );
      if (pathList.length == 0) {
        btnOptmisationConfirm.setAttribute("disabled", true);
      } else {
        btnOptmisationConfirm.removeAttribute("disabled");
      }
    };

    signatureEmptyValidation();

    for (const path of pathList) {
      path.addEventListener("click", (event) => {
        // if touch device
        if (AppSettings.isTouchDevice()) {
          event.target.addEventListener("click", (event) => {
            // check if contains highlight class
            if (event.target.classList.contains("highlight")) {
              event.target.remove();
              signatureEmptyValidation();
              // TODO : Check if require to keep highlighted which is not deleted
            }
          });
        } else {
          // remove on click
          event.target.remove();
          signatureEmptyValidation();
        }

        event.target.remove();
      });

      path.addEventListener("mouseenter", (event) => {
        event.target.classList.add("highlight");
        event.target.style.cursor = "url(" + eraser + "), auto";
      });

      path.addEventListener("mouseleave", (event) => {
        event.target.classList.remove("highlight");
      });
    }
  }

  // * rotate signature handler
  rotateSignatureHandler(svgArea, direction) {
    this.rotateStatus = true;

    const svgElement = svgArea.querySelector("svg");
    const degree = METAL_FEATURES.ROTATE.DEGREE;
    let currentDeg;

    // svg initial dimensions
    let svgW, svgH;
    svgW = svgElement.width.baseVal.valueAsString;
    svgH = svgElement.height.baseVal.valueAsString;

    // check the synced value of clockwise for anti clock
    if (direction === METAL_FEATURES.ROTATE.LEFT) {
      currentDeg = -degree + parseInt(svgArea.dataset.degree);
    } else if (direction === METAL_FEATURES.ROTATE.RIGHT) {
      currentDeg = degree + parseInt(svgArea.dataset.degree);
    }

    // reset degree when it exceeds 360
    if (currentDeg === 360 || currentDeg === -360) {
      svgElement.classList.add("no-transition");
      currentDeg = 0;
    } else {
      svgElement.classList.remove("no-transition");
    }

    if (currentDeg === 90 || currentDeg === -90) {
      // set width as a height value for 90 deg
      svgElement.setAttribute("width", svgH);
    }

    // Fit svg under the svg area in any ratio of signature
    const svgAreaHeight = svgArea.getBoundingClientRect().height;
    const svgAreaWidth = svgArea.getBoundingClientRect().width;
    if (currentDeg === 0 || currentDeg === 180 || currentDeg === -180) {
      svgElement.style.width = svgAreaWidth;
    } else {
      svgElement.style.width = svgAreaHeight;
    }

    svgElement.style.transform = `rotate(${currentDeg}deg)`;
    // set origin
    svgElement.style.transformOrigin = "center";
    
    svgArea.dataset.degree = currentDeg;

    // this require when we sync with canvas at the same - however we are handling everything in SVG :)
    AppSettings.rotatePoint = currentDeg;
    this.rotatePoint = currentDeg;
  }

  // store selected signature
  clickToStore() {
    const pathList = renderedSVG.querySelectorAll("svg g path");

    for (const path of pathList) {
      path.addEventListener("click", (event) => {
        event.target.classList.add("selected");
        this.copySelectedPath();
        // todo remove extra attributes from selected path
      });

      path.addEventListener("mouseenter", (event) => {
        event.target.classList.add("highlight");
        event.target.style.cursor = "url(" + selectCursor + "), auto";
      });

      path.addEventListener("mouseleave", (event) => {
        event.target.classList.remove("highlight");
      });
    }

    // share untouched svg to canvas
    AppSettings.signatureSelectedSVG = renderedSVG.querySelector("svg");
  }

  // * keep the selected path in temp svg
  copySelectedPath() {
    const selectedPath = renderedSVG.querySelectorAll("svg g .selected");
    const signatureSelected = renderedSVG.querySelector("svg").cloneNode(true);
    signatureSelected.id = "filteredSignatureSvg";

    let filteredSvg = "";
    for (const path of selectedPath) {
      filteredSvg += path.outerHTML;
    }

    // todo will use core function from metal
    function stringToHTMLDiv(str) {
      const dom = document.createElement("div");
      dom.innerHTML = str;
      return dom;
    }

    const $filteredPathHTML = stringToHTMLDiv(filteredSvg);

    // reset signature svg child and put new selected path
    signatureSelected.querySelector("g").innerHTML = "";
    signatureSelected.querySelector("g").innerHTML =
      $filteredPathHTML.innerHTML;

    this.optimisedStrokeSign = signatureSelected.innerHTML;

    // share final selected files for the canvas
    AppSettings.signatureSelectedSVG = signatureSelected;
  }

  // reset signature
  resetSignature() {
    this.rotateStatus = false;
  }
}
